import React, { useEffect, useRef, useState } from "react";
import "./NewTradingHistory.scss";
import ReactTable from "../ReactTable/ReactTable";
import { ReactComponent as UncheckedCheckbox } from "../../assets/icons/NewIcons/uncheckedCheckbox.svg";
import { ReactComponent as CheckedCheckbox } from "../../assets/icons/NewIcons/checkedCheckboxWhite.svg";
import { ReactComponent as AddIcon } from "../../assets/icons/NewIcons/AddIconWhite.svg";
import dayjs from "dayjs";
import CreateTrader from "../Trademate/CreateTrader";
import CombinedPopup from "../Popups/CombinedPopup";
import { fetchTraderJournalCreate } from "../../store/reducers/trademateReducer";
import { useDispatch } from "react-redux";
import { FormatUSD } from "../../utilities/string";
import { useNavigate } from "react-router";

const NewTradingHistory = ({ TradingHistory, add = true }) => {
  const formatDate = (dateString) => {
    return dayjs(dateString).format("DD MMM YYYY");
  };

  const formatTime = (dateString) => {
    return dayjs(dateString).format("HH:mm:ss");
  };

  const sortedTradingHistory =
    TradingHistory &&
    TradingHistory?.slice().sort((a, b) => {
      return new Date(b.tradeDateTime).getTime() - new Date(a.tradeDateTime).getTime();
    });

  // POPUP States
  const [Show, setShow] = useState(false);
  const navigate = useNavigate();
  const [CombinedPUHead, setCombinedPUHead] = useState("");
  const [SPopup, setSPopup] = useState(false);
  const [CombinedPUBody, setCombinedPUBody] = useState("");
  const [PopUpType, setPopUpType] = useState("");
  const [candleStickModal, setCandleStickModal] = useState(false);
  const [candleStickSymbol, setCandleStickSymbol] = useState(null);
  const [selectedTradeDate, setSelectedTradeDate] = useState(null);
  const [positionInfo, setPositionInfo] = useState({});
  const [positions, setPositions] = useState({});
  const [period, setPeriod] = useState({
    start_date: null,
    end_date: null,
  });
  const [candleStickTime, setCandleStickTime] = useState(null);
  const [active, setActive] = useState(null);
  const [activeTimeFrame, setActiveTimeFrame] = useState(null);

  const timeFrames = {
    "1d": ["1m", "5m", "15m", "30m", "1h", "3h"],
    "1w": ["1h", "3h", "6h", "12h", "1d"],
    "1m": ["1d", "1w"],
    "3m": ["1d", "1w", "1m"],
    "6m": ["1d", "1w", "1m"],
    "1y": ["1d", "1w", "1m"],
  };

  const getSymbol = (trade) => {
    const symbol = trade?.symbol || trade?.instrument;
    return symbol;
  }
  const getPosition = (trade) => {
    const position = trade?.position || trade?.positionId;
    return position;
  }
  const getTradeDateTime = (trade) => {
    const tradeDate = trade?.date || trade?.tradeDateTime;
    return tradeDate
  }

  const containerRef = useRef(null);

  useEffect(() => {
    handleClick("1d");
  }, []);

  const handleRowClick = (row) => {
    const clickedPosition = getPosition(row?.original);

    const matchingItems = filteredData?.filter(
      (item) => getPosition(item) === clickedPosition
    );

    setPositionInfo((prev) => ({
      ...prev,
      info: matchingItems,
      [matchingItems?.length > 1 ? "first" : "second"]: false,
      [matchingItems?.length > 1 ? "second" : "first"]: true,
    }));

    const newPositions = matchingItems.reduce((acc, item) => {
      if (getPosition(item) && getTradeDateTime(item)) {
        const date = new Date(getTradeDateTime(item));
        date.setSeconds(0, 0);
        const formattedDate = `${date.getUTCFullYear()}-${String(
          date.getUTCMonth() + 1
        ).padStart(2, "0")}-${String(date.getUTCDate()).padStart(2, "0")}T${String(
          date.getUTCHours()
        ).padStart(2, "0")}:${String(date.getUTCMinutes()).padStart(2, "0")}:00Z`;
        if (acc[getPosition(item)]) {
          acc[getPosition(item)].push(formattedDate);
        } else {
          acc[getPosition(item)] = [formattedDate];
        }
      }
      return acc;
    }, {});

    // Prepare the time period
    const selectedDate = getTradeDateTime(row.original);
    const { startDate, endDate } = calculateDates("1d", selectedDate);

    // Save state before navigation
    setSelectedTradeDate(selectedDate);
    setCandleStickSymbol(getSymbol(row.original));
    setCandleStickTime(selectedDate);
    setPositions(newPositions);
    setPeriod({ start_date: getTradeDateTime(matchingItems?.[0]), end_date: getTradeDateTime(matchingItems?.[1]) });
    setPositionInfo({
      info: matchingItems,
      first: true,
      second: false,
    });

    // navigate("/trade-details", {
    //   state: {
    //     positionInfo: {
    //       info: matchingItems,
    //       first: true,
    //       second: false,
    //     },
    //     period: {
    //       start_date: getTradeDateTime(matchingItems?.[0]),
    //       end_date: getTradeDateTime(matchingItems?.[1]),
    //     },
    //     selectedTradeDate: selectedDate,
    //     candleStickSymbol: getSymbol(row.original),
    //     candleStickTime: selectedDate,
    //     positions: newPositions,
    //   },
    // });



    const stateData = {
      positionInfo: {
        info: matchingItems,
        first: true,
        second: false,
      },
      period: {
        start_date: getTradeDateTime(matchingItems?.[0]),
        end_date: getTradeDateTime(matchingItems?.[1]),
      },
      selectedTradeDate: selectedDate,
      candleStickSymbol: getSymbol(row.original),
      candleStickTime: selectedDate,
      positions: newPositions,
    };
    sessionStorage.setItem("tradeDetailsState", JSON.stringify(stateData));
    

  };


  useEffect(() => {
    if (
      positionInfo &&
      period &&
      selectedTradeDate &&
      candleStickSymbol &&
      candleStickTime &&
      positions
    ) {
      // navigate("/trade-details", {
      //   state: {
      //     positionInfo,
      //     period,
      //     selectedTradeDate,
      //     candleStickSymbol,
      //     candleStickTime,
      //     positions,
      //   },
      // });
      window.open("/trade-details", "_blank");
    }


  }, [
    positionInfo,
    period,
    selectedTradeDate,
    candleStickSymbol,
    candleStickTime,
    positions,
  ]);


  const calculateDates = (period, storedDate) => {
    const storedDateObj = new Date(storedDate);
    if (isNaN(storedDateObj.getTime())) {
      throw new Error("Invalid stored date");
    }

    let startDate = new Date(storedDateObj);
    let endDate = new Date(storedDateObj);

    switch (period) {
      case "1d":
        break;
      case "1w":
        startDate.setDate(startDate.getDate() - 3);
        endDate.setDate(endDate.getDate() + 3);
        break;
      case "1m":
        startDate.setMonth(startDate.getMonth() - 1);
        endDate.setMonth(endDate.getMonth() + 1);
        break;
      case "3m":
        startDate.setMonth(startDate.getMonth() - 3);
        endDate.setMonth(endDate.getMonth() + 3);
        break;
      case "6m":
        startDate.setMonth(startDate.getMonth() - 6);
        endDate.setMonth(endDate.getMonth() + 6);
        break;
      case "1y":
        startDate.setFullYear(startDate.getFullYear() - 1);
        endDate.setFullYear(endDate.getFullYear() + 1);
        break;
      default:
        startDate = new Date(0);
        endDate = new Date();
        break;
    }

    return {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    };
  };

  const dispatch = useDispatch();

  const handleClick = (value) => {
    setActive(value);
    const { startDate, endDate } = calculateDates(value, selectedTradeDate);

    if (value !== "1d") {
      setCandleStickTime(null);
    }
    if (value === "1d") {
      setCandleStickTime(selectedTradeDate);
    }
    setActiveTimeFrame(timeFrames?.[value]?.[0]);
  };

  const handleFormSubmit = (Data) => {
    dispatch(fetchTraderJournalCreate(Data))
      .then((res) => {
        if (res) {
          setSPopup(true);
          setCombinedPUHead("Success");
          setCombinedPUBody("Journal created!");
          setPopUpType("success");
        } else {
          setSPopup(true);
          setCombinedPUHead("Error");
          setCombinedPUBody("Something went wrong");
          setPopUpType("error");
        }
      })
      .catch((error) => {
        alert("Error");
      });
  };

  const filters = ["Profit", "Buy", "Sell"];
  const [createTradeVisibility, setCreateTradeVisibility] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [filterVisibility, setFilterVisibility] = useState(false);
  const filterRef = useRef(null);
  const buttonRef = useRef(null);
  const traderRef = useRef(null);
  const tradeButtonRef = useRef(null);
  const [filteredData, setFilteredData] = useState(TradingHistory);

  const filterFunctions = {
    Profit: (trade) => trade.profit > 0,
    Buy: (trade) => trade.side === "Buy" || trade.action === "Buy",
    Sell: (trade) => trade.side === "Sell" || trade.action === "Sell",
  };

  const applyFilters = () => {
    if (!TradingHistory || TradingHistory.length === 0) {
      setFilteredData([]);
      return;
    }

    const activeFilters = Object.keys(selectedFilters).filter(
      (key) => selectedFilters[key]
    );

    if (activeFilters.length === 0) {
      setFilteredData(TradingHistory);
      return;
    }

    const filtered = TradingHistory.filter((trade) =>
      activeFilters.every((filter) => filterFunctions[filter](trade))
    );

    setFilteredData(filtered);
  };

  useEffect(() => {
    applyFilters();
  }, [selectedFilters, TradingHistory]);

  const handleFilterToggle = (filter) => {
    setSelectedFilters((prevFilters) => {
      const newFilters = {};
      // Set all filters to false
      filters.forEach((f) => {
        newFilters[f] = false;
      });
      // Toggle the selected filter
      newFilters[filter] = !prevFilters[filter];
      return newFilters;
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        filterRef.current &&
        !filterRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setFilterVisibility(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleCross = () => {
    setCreateTradeVisibility(false);
  };

  useEffect(() => {
    if (createTradeVisibility) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [createTradeVisibility]);

  const columnss =
    Array.isArray(filteredData) && filteredData.length > 0
      ? Object.keys(filteredData[0])?.map((key) => {
        let columnProps = {
          Header: key
            .replace(/_/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase()),
          accessor: key,
          Cell: ({ value }) => <div>{value ?? "N/A"}</div>,
        };

        if (key === "profit" || key === "netProfit") {
          columnProps.Cell = ({ value }) => (
            <div
              className={
                value > 0 ? "profitValue" : value < 0 ? "lossValue" : ""
              }
            >
              {FormatUSD(value) ?? "0"}
            </div>
          );
        } else if (key === "tradeDateTime") {
          columnProps.Cell = ({ value }) => (
            <div className="dateBox">
              <p>{value ? formatDate(value) : "N/A"}</p>
              <p>{value ? formatTime(value) : "N/A"}</p>
            </div>
          );
        } else if (key === "instrument") {
          columnProps.Cell = ({ row }) => (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span>{row.original.instrument ?? "N/A"}</span>
            </div>
          );
        } else if (key === "positionSide") {
          columnProps.Cell = ({ value }) => (
            <div
              className={`${value === "Buy" ? "profitValue" : value === "Sell" ? "lossValue" : ""}`}
            >
              {value ?? "N/A"}
            </div>
          );
        }

        return columnProps;
      })
      : [];

  const newColumn = {
    Header: "Chart",
    accessor: "newColumn",
    Cell: ({ row }) => (
      <div
        style={{
          background:
            "var(--Gradient-1, radial-gradient(453.04% 131.96% at 1.22% 92.31%, #0d56eb 0%, #0640b9 100%))",
          borderRadius: "5px",
          padding: "4px 5px",
          cursor: "pointer",
        }}
        onClick={() => {
          setCandleStickModal(true);
          setCandleStickSymbol(row.original.instrument);
          setSelectedTradeDate(row.original.tradeDateTime);
          setCandleStickTime(row.original.tradeDateTime);
          handleRowClick(row);
        }}
      >
        Open Chart
      </div>
    ),
  };

  columnss.splice(1, 0, newColumn);

  return (
    <div className="newTradeHistoryContainer">
      <div className="headerSection">
        <h3>Trading Activity</h3>
        <div className="filter_container">
          {add && (
            <button
              className="addButton"
              ref={tradeButtonRef}
              onClick={() => setCreateTradeVisibility((prev) => !prev)}
            >
              <AddIcon />
              Add Trade
            </button>
          )}
          <button
            ref={buttonRef}
            onClick={() => setFilterVisibility((prev) => !prev)}
          >
            Filters
          </button>
          <div
            ref={filterRef}
            className={`filterWrapper ${filterVisibility ? "filterVisible" : "filterHidden"
              }`}
          >
            {TradingHistory && TradingHistory.length > 0 ? (
              filters?.map((filter) => (
                <div
                  className={`filterItems ${selectedFilters[filter] ? "checked" : ""
                    }`}
                  key={filter}
                  onClick={() => handleFilterToggle(filter)}
                  style={{ cursor: "pointer" }}
                >
                  {selectedFilters[filter] ? (
                    <CheckedCheckbox />
                  ) : (
                    <UncheckedCheckbox />
                  )}
                  <span style={{ color: "#fff" }}>{filter}</span>
                </div>
              ))
            ) : (
              <div style={{ textAlign: "center", color: "#fff" }}>
                No Data to filter
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="newTradeHistoryWrapper">
        <ReactTable columns={columnss || []} data={(filteredData || []).reverse()} />
      </div>
      <div
        className={`createTradeJournalContainer ${createTradeVisibility ? "traderVisible" : "traderHidden"
          }`}
      >
        <div className="createJournalWrapper" ref={traderRef}>
          <CreateTrader handleCross={handleCross} handleFormSubmit={handleFormSubmit} />
        </div>
        <CombinedPopup
          type={PopUpType}
          trigger={SPopup}
          setTrigger={setSPopup}
          head={CombinedPUHead}
          subhead={CombinedPUBody}
          setShow={setShow}
        />
      </div>
      {/* {candleStickModal && (
        <div className="candleChart">
          <div className="candleChartHeader">
            <div className="candle-chart-filter" ref={containerRef}></div>
            <button
              className="close-button"
              onClick={() => {
                setCandleStickModal(false);
                setCandleStickTime(null);
                setCandleStickSymbol(null);
                setActive("1d");
              }}
            >
              ×
            </button>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default NewTradingHistory;